'use client';

import { ReactNode } from 'react';
import { TranslationContext } from './TranslationContext';

type TranslationProviderProps = {
  translations: any;
  children: ReactNode;
};

export function TranslationProvider({ translations, children }: TranslationProviderProps) {
  return <TranslationContext.Provider value={translations}>{children}</TranslationContext.Provider>;
}
